import SwapTemplateModal from '@/components/Packaging/SwapTemplateModal/SwapTemplateModal';
import { useAppSelector } from '@/redux/hooks';
import { selectIsPackagingDraft } from '@/redux/selectors/packagingSelectors';
import styled from '@emotion/styled';
import { IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import PolarisIcon from '../_common/PolarisIcon';

const AssemblyTemplateSwapButton: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const isDraft = useAppSelector(selectIsPackagingDraft);

  return (
    <>
      <Tooltip title="Swap Template">
        <TemplateSwapIconButton color="primary" onClick={() => setModalOpen(true)} disabled={!isDraft}>
          <PolarisIcon icon="swap" height={14} />
        </TemplateSwapIconButton>
      </Tooltip>
      <SwapTemplateModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default AssemblyTemplateSwapButton;

const TemplateSwapIconButton = styled(IconButton)`
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  svg {
    transform: rotate(90deg);
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};
  }
`;
